export default {
    columns: Array, 
    measures: Array, 
    rows: Array, 
    transport: Object, 
    schema: Object
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotDataSource/PivotDataSourceProps.js